import { IRule } from '../components/Rules/RuleContent/RuleContent'
import { IRuleOption } from '../components/Rules/Rules'
import { buildParams } from '../utils/useQueryParams'

import axiosAuth from './axiosAuth'

export const getRules = (
    controller: AbortController,
    filters: Record<string, (string | null)[] | null | undefined>
) => {
    const params = filters && new URLSearchParams(buildParams(filters))

    return axiosAuth.get<IRuleOption[]>(`/rules${params ? `?${params}` : ''}`, {
        signal: controller.signal,
    })
}

interface IRequestGetRulesFilters {
    intent_names: string[]
    action_names: string[]
}

export const getRulesFilters = (controller: AbortController) =>
    axiosAuth.get<IRequestGetRulesFilters>('/rules/filters', {
        signal: controller.signal,
    })

export const getRuleData = (controller: AbortController, ruleId: string) =>
    axiosAuth.get<IRule>(`/rules/${ruleId}`, {
        signal: controller.signal,
    })

export const putRuleData = (ruleId: string, ruleData: string) =>
    axiosAuth.put<string>(`/rules/${ruleId}`, ruleData)

export const postRuleData = (ruleData: string) =>
    axiosAuth.post(`/rules`, ruleData)

export const deleteRuleData = (ruleId: string) =>
    axiosAuth.delete(`/rules/${ruleId}`)
